module.exports = __webpack_public_path__ + "static/media/ten.6cec4a9f.jpg";